exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.loader {\n  margin: auto;\n  vertical-align: middle;\n}\ndiv.loader svg path,\ndiv.loader svg rect {\n  fill: #c8017d;\n}", ""]);

// exports
